export enum ModuleType {
    Core = 1,
    Document = 2,
    MediaBank = 3,
    Email = 4,
    Post = 5,
    NewsFeed = 6,
    Template = 7,
    Widget = 9,
    Tag = 10,
    Event = 11,
    Statistics = 12,
    FirstPage = 14,
    Billing = 16,
    ConfidentialAgreement = 17,
    SMS = 18,
    CheckList = 19,
    ForumPost = 20,
    CheckListReports = 21,
    ADIntegration = 22,
    Statistics2 = 23,
    Form = 24,
    FormReports = 25,
    Task = 26,
    ForumAdmin = 27,
    Chat = 28,
    Personalkollen = 46, // todo wrong module type? should be 29
    Planday = 31,
    ChecklistV2 = 32,
    ChecklistV2Reports = 33,
    ChecklistV2Audit = 34,
    ChecklistV2AuditReports = 35,
    TaskV2 = 36,
    TaskV2Reports = 37,
    LoginReminder = 38,
    Onboarding = 39,
    OnboardingReports = 40,

    CustomFranchiseIntranetUpgrade = 103, //Used by Chainformation customer
    CustomerBilling = 105, //Used by Chainformation customer
    // WordImport = 106
}
